<template>

  <div>
    <!-- navbar -->
    <Navigation> </Navigation>
    <!-- navbar -->

    <!-- one compony -->
    <section id="home" class="noselect section-main-container"  >
      <div class="container">
        <div class="row">
          <div class="col-lg-5 col-md-5 col-sm-12 col-xs-12">
            <div>
              <!-- typing animation - START -->

              <!-- typing animation - END -->
              <h3 class="home-content-heading">
                <strong>One Company.<br />One Unified Platform</strong>
              </h3>
              <span class="lead">Web. Mobile. Anytime. Anywhere.</span>
              <br /><br />
              <h4>End-to-End Integrated Apps</h4>

              <span
                >Aruvaa provides simple, valuable &amp; trusted experiences with
                technology to continuously improve the way people manage,
                automate, optimize their lives and work.</span
              >
              <br />
              <br />

              <a href="#tabs" id="scrollbtna">
                <button  class="get-trial-button">
                  <span>Get Free Trial </span>
                </button>
              </a>
              <!-- @endif
                    @endauth
                    @endif-->
            </div>
          </div>
          <div class="col-lg-7 col-md-7 col-sm-12 col-xs-12">
            <img src="imgs/Aruvaa_img1.png" class="img-fluid" alt="" />
          </div>
        </div>
      </div>
    </section>

     <!-- 2nd section start -->
     <section  class="py-5" style="background-color:rgba(246, 246, 246, 0.33)">
    <div class="container tabs" id="tabs">
      <h4 class="font-semibold leading-tighter">How to Start Using</h4>
      <h4 class="font-semibold text-blue-500 mb-2">Your First Saas</h4>
      <div class="grid grid lg:grid-cols-4 sm:grid-cols-2  gap-3 ">
        <div  class=" "> 

          <div class="grid lg:col-span-1 grid-cols-1  gap-2 cursor-pointer">

            <!-- ... -->
            <div @click="productsFilter('Grow')" class="bg-gray-100  first_saas px-3 py-2 flex  active ">
              <div class="mr-3">
                <img src="imgs/ic1.png" class="img-fluid team" 
              />
              </div>
              <div class="">
                  <h6 class="font-semibold text-lg leading-none">Grow</h6>
                  <p class="text-sm">Sales & Marketing</p>
              </div>
            </div>
            <!-- ... -->
            <div @click="productsFilter('Customer')" class="bg-gray-100  first_saas px-3 py-2 flex ">
              <div class="mr-3">
                <img src="imgs/ic2.png" class="img-fluid team " 
              />
              </div>
              <div>
                  <h6 class="font-semibold text-lg leading-none">Customer</h6>
                  <p class="text-sm">Sales & Marketing</p>
              </div>
            </div>
          
            <div @click="productsFilter('Money')" class="bg-gray-100 first_saas px-3 py-2 flex ">
              <div class="mr-3">
                <img src="imgs/ic3.png" class="img-fluid team" 
              />
              </div>
              <div>
                  <h6 class="font-semibold text-lg leading-none">Money</h6>
                  <p class="text-sm">Sales & Marketing</p>
              </div>
            </div>
          
            <div  @click="productsFilter('People')" class="bg-gray-100 first_saas px-3 py-2 flex ">
              <div class="mr-3">
                <img src="imgs/ic4.png" class="img-fluid team" 
              />
              </div>
              <div>
                  <h6 class="font-semibold text-lg leading-none">People</h6>
                  <p class="text-sm">Sales & Marketing</p>
              </div>
            </div>
          
            <div @click="productsFilter('Engage')" class="bg-gray-100 first_saas px-3 py-2 flex ">
              <div class="mr-3">
                <img src="imgs/ic5.png" class="img-fluid team" 
              />
              </div>
              <div>
                  <h6 class="font-semibold text-lg leading-none">Engage</h6>
                  <p class="text-sm">Sales & Marketing</p>
              </div>
            </div>
            
            <div @click="productsFilter('Collaborate')" class="bg-gray-100 first_saas px-3 py-2 flex">
              <div class="mr-3">
                <img src="imgs/ic6.png" class="img-fluid team" 
              />
              </div>
              <div>
                  <h6 class="font-semibold text-lg leading-none">Collaborate</h6>
                  <p class="text-sm">Sales & Marketing</p>
              </div>
            </div>
            
          </div>

        </div>
        <!-- ... -->

        <!-- Right side card start -->
          <div v-show="productsData.length > 0 " class="lg:col-span-3 grid-cols-2 smallCard">      
            <div class="grid lg:grid-cols-3  md:grid-cols-1 sm:grid-cols-1 xs:grid-cols-1 xs:ml-4 gap-2">
              
                <div v-for="(product , index) in productsData" class="max-w-sm rounded overflow-hidden border border-gray-500">
                  <!-- <img class="w-full" src="/img/card-top.jpg" alt="Sunset in the mountains"> -->
                 
                  <div class="" :style="{ backgroundColor: getRandomColor(index)  }">
                    <img class="py-4" src="/imgs/cell.png" alt="" style="margin: auto">
                  </div>
                 
                  <div class="px-3 py-1">
                    <div class=" ">
                      <div class="font-bold text-md">{{product.name}}</div>
                      <p class="text-gray-700 text-xs">
                      {{product.full_name}}
                      </p>
                    </div>
                  
                    <a  :href="'marketplaces/productpages/'+product.id" >
                      <div class="  flex justify-start pt-1">
                      <span class="text-xs font-bold text-blue-800 hover:text-blue-900 uppercase">LEARN MORE
                      
                      <i class="fa fa-long-arrow-right" aria-hidden="true"></i>
                      </span>
                    </div>
                    </a> 
                  </div>
                
                </div>
                <!-- ... -->
             
            
            </div>
          </div>
        <!-- Right side small card end -->

           <!-- Right side card start -->
         <div v-show="productsData.length <= 0 " class="lg:col-span-3 grid-cols-2 longCard" style="background-color: #F4F8FE;">
            <div class="grid xl:grid-cols-2 lg:grid-cols-2 md:grid-cols-2 grid-cols-1 gap-2  px-3">
            <div class="py-5  px-2">
              <p  class="text-xs text-gray-700 mt-4">A game-changing SaaS solution designed</p>

              <h4 class="mt-3 font-semibold " style="color:#00ACCD">Coming Soon</h4>
              <h4 class="font-semibold">Elevating Your Business with Next-Gen Saas Solutions</h4>

              <p class="text-gray-500">Regular updates and valuable resources to keep you in the loop.</p>
            </div>
            
            <div class="py-5 px-2">
              <img src="imgs/Aruvaa_coming.png" class="img-fluid" alt="" />
            </div>
          </div>
          </div>
        <!-- Right side  card end -->   


      </div>
    </div>
   </section>
    <!-- 2nd section end -->

    <!-- 2nd section trial start -->
    <!-- <div class="container">
      <div class="grid lg:grid-cols-4 sm:grid-cols-2  gap-4">
        <div  class="border lg:col-span-1 grid-cols-2">1</div>
      
        <div class="lg:col-span-3 grid-cols-2 border">
          <div class="grid lg:grid-cols-3 grid-cols-1 gap-2">
            <div class="bg-red-500">2</div>
           
            <div class="bg-blue-500">3</div>
           
            <div class="bg-green-500">4</div>
          </div>
        </div>
      </div>
    </div> -->
    <!-- 2nd section trial end -->

    <!-- what makes aruvaa unique -->
    <section id="benefit" class="noselect section-main-container">
      <div class="container title-section">
        <h2 class="text-center mb-4">What makes aruvaa unique?</h2>
        <div class="row">
          <div class="col-lg-6 col-md-12 col-sm-12 col-xs-12">
            <table style="width: 100%">
              <tr>
                <td class="lead icon_style unique-style">
                  <!-- icon will be here -->
                  <i class="far fa-window-restore"></i>
                </td>
                <td class="pl-2">
                  <span class="lead unique-style">
                    Unified Management - Single Console
                  </span>
                  <div class="lorem-style mb-2">
                    Manage your work with a single yet powerful console
                  </div>
                </td>
              </tr>
              <tr>
                <td class="lead icon_style unique-style">
                  <!-- icon will be here -->
                  <i class="fas fa-network-wired"></i>
                </td>
                <td class="pl-2">
                  <span class="lead unique-style"> Integrated </span>
                  <div class="lorem-style mb-2">
                    Integrated with different libraries and technologies
                  </div>
                </td>
              </tr>
              <tr>
                <td class="lead icon_style unique-style">
                  <!-- icon will be here -->
                  <i class="fas fa-hands-helping"></i>
                </td>
                <td class="pl-2">
                  <span class="lead unique-style"> Collaborative</span>
                  <div class="lorem-style mb-2">
                    Collatorate your work with on a single platform
                  </div>
                </td>
              </tr>

              <tr>
                <td class="lead icon_style unique-style">
                  <!-- icon will be here -->
                  <i class="fas fa-magic"></i>
                </td>
                <td class="pl-2">
                  <span class="lead unique-style">Automation </span>
                  <div class="lorem-style mb-2">
                    Our advanced automation can save your precious time
                  </div>
                </td>
              </tr>
              <tr>
                <td class="lead icon_style unique-style">
                  <!-- icon will be here -->
                  <i class="fas fa-balance-scale-right"></i>
                </td>
                <td class="pl-2">
                  <span class="lead unique-style">Scalable</span>
                  <div class="lorem-style mb-2">
                    Scale your business with an ease, using a single platform
                  </div>
                </td>
              </tr>
              <tr>
                <td class="lead icon_style unique-style">
                  <!-- icon will be here -->
                  <i class="fas fa-users"></i>
                </td>
                <td class="pl-2">
                  <span class="lead unique-style">
                    Manage - Time, Money &amp; People</span
                  >
                  <div>
                    <div class="lorem-style mb-2">
                      A better way to manage your time, money &amp; people
                    </div>
                  </div>
                </td>
              </tr>
            </table>
          </div>

          <div class="col-lg-6 col-md-12 col-sm-12 col-xs-12">
            <img
              src="imgs/ic_unique.png"
              alt=""
              class="img-fluid home-banner-image"
            />
          </div>
        </div>
      </div>
    </section>

    <!-- what's in it for me -->
    <section class="section-main-container colored-section">
      <div class="container">
        <div class="title-section">
          <h2 class="text-center mb-4">WIIFM - What's in it for me ?</h2>
        </div>
        <div class="row">
          <div class="col-lg-3 col-md-6 col-sm-6">
            <div class="wiifm-container text-center mt-2">
              <img src="imgs/ic_growth.png" class="img-fluid wiifm-img" />
              <div class>
                <h5>Scalable</h5>
                <p class="p2">
                  Manage unlimited number of businesses and scale them according
                  to your requirement.
                </p>
              </div>
            </div>
          </div>
          <div class="col-lg-3 col-md-6 col-sm-6">
            <div class="wiifm-container text-center mt-2">
              <img
                src="imgs/ic_future_ready.png"
                style="display: inline-block"
                class="img-fluid wiifm-img"
              />
              <div class="">
                <h5>Future Ready</h5>
                <p class="p2">
                  Use our future ready platform to boost your business growth
                  easily and seamlessly.
                </p>
              </div>
            </div>
          </div>
          <div class="col-lg-3 col-md-6 col-sm-6">
            <div class="wiifm-container text-center mt-2">
              <img
                src="imgs/ic_fully_automated.png"
                class="img-fluid wiifm-img"
              />
              <div class="">
                <h5>Fully Automated</h5>
                <p class="p2">
                  Our Platform is easy to use and most of the products are
                  automated which makes your work faster
                </p>
              </div>
            </div>
          </div>
          <div class="col-lg-3 col-md-6 col-sm-6">
            <div class="wiifm-container text-center mt-2">
              <img src="imgs/ic_flexible.png" class="img-fluid wiifm-img" />
              <div class="">
                <h5>Flexible</h5>
                <p class="p2">
                  Lorem ipsum dolor sit amet, consectetur adipisicing elit.
                  Placeat pariatur maiores maxime!
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <!-- Advantages for "you" -->
    <section class="  noselect section-main-container">
      <div class="container">
             <h2 class="text-center mb-4 font-bold">Advantages For "YOU"</h2>
       <div class="grid lg:grid-cols-3  md:grid-cols-3 sm:grid-cols-2 xs:grid-cols-1 gap-4">
        <div class="team-container  place-items-center d-flex px-2 py-3">
            <img src="imgs/Quality.png" class="img-fluid team" height="80px" width="80px"
             />
              <span class="ml-3"> 
               <h6>Quality &amp; Reliability</h6>
                  <p class="p-adv">
                    We build high quality solutions, which meets your
                    requirements and business model.
                  </p>
              </span>
        </div>
          <div class="team-container  place-items-center d-flex px-2 py-3">
            <img src="imgs/best price.png" class="img-fluid team" height="80px" width="80px"
             />
              <span class="ml-3"> 
                <h6>Best Prices &amp; Offers</h6>
                  <p class="p-adv">
                    Just pay for what you use with Aruvaa's flexible and low
                    cost pricing.
                  </p>
              </span>
        </div>
         <div class="team-container  place-items-center d-flex px-2 py-3">
            <img src="imgs/EasySetup and Integration.png" class="img-fluid team" height="80px" width="80px"
             />
              <span class="ml-3"> 
                <h6>Easy Setup &amp; Integration</h6>
                  <p class="p-adv">
                    Using the very latest technology Aruvaa can be implemented
                    quickly and without any hastle.
                  </p>
              </span>
        </div>
          <div class="team-container  place-items-center d-flex px-2 py-3">
            <img src="imgs/MultiChannelSupport.png" class="img-fluid team" height="80px" width="80px"
             />
              <span class="ml-3"> 
                 <h6>Multi-Channel Support</h6>
                  <p class="p-adv">
                    Our most experienced support executives are always ready to
                    hold your hands while you are stuck anywhere.
                  </p>
              </span>
        </div>
          <div class="team-container  place-items-center d-flex px-2 py-3">
            <img src="imgs/customer satisfaction.png" class="img-fluid team" height="80px" width="80px"
             />
              <span class="ml-3"> 
                 <h6>Customer Satisfaction</h6>
                  <p class="p-adv">
                    Customer satisfaction shouldn't just belong to a department,
                    it should depend on the entire company.
                  </p>
              </span>
        </div>
       </div>
      </div>
    </section>

     <DxLoadPanel
      :position="position"
      v-model:visible="loadingVisible"
      :show-indicator="showIndicator"
      :show-pane="showPane"
      :shading="shading"
      :close-on-outside-click="closeOnOutsideClick"
      :on-shown="onShown"
      :on-hidden="onHidden"
      shading-color="rgba(0,0,0,0.4)"
    />

    <!-- team intro ends -->
    <Footer> </Footer>
  </div>
</template>
<script>
import { Head, Link } from "@inertiajs/inertia-vue3";
import Navigation from "@/Layouts/Navigation.vue";
import Footer from "@/Layouts/Footer.vue";
import AppLayout from "@/Layouts/AppLayout.vue";
import Welcome from "@/Jetstream/Welcome.vue";
import JetNavLink from '@/Jetstream/NavLink.vue';
import { DxLoadPanel } from 'devextreme-vue/load-panel';


export default {
  data() {
    return {
    colors:[  
    '#F2F6FD', '#F2FDFB','#FDF2F2', '#E4FAD9', '#FAF2FD','#EAE6F5'
    ],

      Products:[],
      productsData:[],

      selected_category:'Grow',
      selectedColor: "",
      isActive1: true,
      isActive2: false,
      isActive3: false,
      isActive4: false,
      isActive5: false,
      isActive6: false,
      canRegister: true,
      catProducts: [],
      loadingVisible: false,
      // position: { of: '#productContainer' },
      showIndicator: true,
      shading: true,
      showPane: true,
      closeOnOutsideClick: false,
    };
  },
  methods: {
   

    toggle(tab) {
      this.isActive6 = tab == "Collaborate" ? true : false;
      this.isActive5 = tab == "Engage" ? true : false;
      this.isActive4 = tab == "People" ? true : false;
      this.isActive3 = tab == "Money" ? true : false;
      this.isActive2 = tab == "Customer" ? true : false;
      this.isActive1 = tab == "Grow" ? true : false;

      this.getProductList(tab);
    },

    productsFilter(category){
      this.selected_category=category;
      let keyToFilter = 'category';
      let filterValue = category;
     this.productsData = this.Products.filter(item => item[keyToFilter] === filterValue);
     console.log('Tarun Sir'  +  this.selected_category);
    },

    getRandomColor(index) {
      
      const colorIndex  = (index % this.colors.length)
      // const randomIndex = Math.floor(Math.random() * this.colors.length);
      // this.selectedColor = this.colors[randomIndex];
      return this.colors[colorIndex];
     
    },

    getProductList() {
      // console.log("Hello Error");
      axios.get("getProducts").then((response) => {
        // console.log("Hello Error");
        this.Products = response.data.data;
        this.productsFilter(this.selected_category);

      })
      .catch((error) => {
        console.log("error find");
      });
    },
 
  },

  components: {
    AppLayout,
    Footer,
    Welcome,
    DxLoadPanel,
    JetNavLink,
    Navigation,
  },
  props: {
    canLogin: Boolean,
    canRegister: Boolean,
  },
  mounted() {
    // console.log($page.props.user);
    this.getProductList();

    $(".first_saas").on("click", function () {
    
      $(".first_saas").removeClass("active");
      $(this).addClass("active");
    });

    

    // $(".offer-link").on("click", function () {
    
    //   $(".offer-link").removeClass("is-active");
    //   $(this).addClass("is-active");
    // });

    //  this.getProductList("Grow");
    //  down scroll button
    $(document).ready(function(){
$("#scrollbtna").click(function() {
    $('html,body').animate({                           //  fine in moz, still quicker in chrome. 
        scrollTop: $(".tabs").offset().top},
        'slow');
});
 }); 
  },
};
</script>

<style scoped>
:root {
  --blue: #0068ca;
  --white: #ffffff;
  --primary: #82c5ff;
  --secondary: #fdc031;
  --black: #333333;
  --input_grey: #d7d7d7;
  --hint_grey: #bfbfbf;
  --pink: #ff4b69;
}
* {
  outline: none;
}

.img-pad {
  padding-left: 20px;
}
/*Scroll - START*/
/* width */
::-webkit-scrollbar {
  width: 5px;
}
/* Track */
::-webkit-scrollbar-track {
  background: #f1f1f1;
}
/* Handle */
::-webkit-scrollbar-thumb {
  background: #888;
}
/* Handle on hover */
::-webkit-scrollbar-thumb:hover {
  background: #555;
}
/*Scroll - END*/
#home{
  background-image: url("/imgs/Aruvaa_Banner3.png");
  background-repeat: no-repeat;
  background-size: cover;

}

.category-container {
  font-size: 14px;
  border: 1px solid var(--blue);
  height: 100px;
  color: var(--black);
  transition: 0.2s;
}
.category-container:hover {
  box-shadow: 0 0 4px 1px var(--blue);
}
.category-container-link:hover {
  text-decoration: none;
}

/* next css */
.wiifm-img {
  display: inline-block;
}
html {
  -webkit-text-size-adjust: 100%;
   overflow-x: hidden;
    line-height: 1.5;
}

a {
  background-color: transparent;
}
[hidden] {
  display: none;
}
*,
:after,
:before {
  box-sizing: border-box;
  border: 0 solid #e2e8f0;
}
a {
  color: inherit;
  text-decoration: inherit;
}
svg,
video {
  display: block;
  vertical-align: middle;
}
video {
  max-width: 100%;
  height: auto;
}
.bg-white {
  --bg-opacity: 1;
  background-color: #fff;
  background-color: rgba(255, 255, 255, var(--bg-opacity));
}
.bg-gray-100 {
  /* --bg-opacity: 1; */
  background-color: #f7fafc;
  /* background-color: rgba(247, 250, 252, var(--bg-opacity)); */
}
.border-gray-200 {
  --border-opacity: 1;
  border-color: #edf2f7;
  border-color: rgba(237, 242, 247, var(--border-opacity));
}
.border-t {
  border-top-width: 1px;
}
.flex {
  display: flex;
}
.grid {
  display: grid;
}
.hidden {
  display: none;
}
.items-center {
  align-items: center;
}
.justify-center {
  justify-content: center;
}
.font-semibold {
  font-weight: 600;
}
.h-5 {
  height: 1.25rem;
}
.h-8 {
  height: 2rem;
}
.h-16 {
  height: 4rem;
}
.text-sm {
  font-size: 0.875rem;
}
.text-lg {
  font-size: 1.125rem;
}
.leading-7 {
  line-height: 1.75rem;
}
.mx-auto {
  margin-left: auto;
  margin-right: auto;
}
.py-4{
  padding-top: 1.75rem !important;
padding-bottom: 1.75rem !important;
}
.ml-1 {
  margin-left: 0.25rem;
}
.mt-2 {
  margin-top: 0.5rem;
}
.mr-2 {
  margin-right: 0.5rem;
}
.ml-2 {
  margin-left: 0.5rem;
}
.mt-4 {
  margin-top: 1rem;
}
.ml-4 {
  margin-left: 1rem;
}
.mt-8 {
  margin-top: 2rem;
}
.ml-12 {
  margin-left: 3rem;
}
.-mt-px {
  margin-top: -1px;
}
.max-w-6xl {
  max-width: 72rem;
}
.min-h-screen {
  min-height: 100vh;
}
.overflow-hidden {
  overflow: hidden;
}
.p-6 {
  padding: 1.5rem;
}
.px-6 {
  padding-left: 1.5rem;
  padding-right: 1.5rem;
}
.pt-8 {
  padding-top: 2rem;
}
.fixed {
  position: fixed;
}
.relative {
  position: relative;
}
.top-0 {
  top: 0;
}
.right-0 {
  right: 0;
}
.shadow {
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px 0 rgba(0, 0, 0, 0.06);
}
.text-center {
  text-align: center;
}
.text-gray-200 {
  --text-opacity: 1;
  color: #edf2f7;
  color: rgba(237, 242, 247, var(--text-opacity));
}
.text-gray-300 {
  --text-opacity: 1;
  color: #e2e8f0;
  color: rgba(226, 232, 240, var(--text-opacity));
}
.text-gray-400 {
  --text-opacity: 1;
  color: #cbd5e0;
  color: rgba(203, 213, 224, var(--text-opacity));
}
.text-gray-500 {
  --text-opacity: 1;
  color: #a0aec0;
  color: rgba(160, 174, 192, var(--text-opacity));
}
.text-gray-600 {
  --text-opacity: 1;
  color: #718096;
  color: rgba(113, 128, 150, var(--text-opacity));
}
.text-gray-700 {
  --text-opacity: 1;
  color: #4a5568;
  color: rgba(74, 85, 104, var(--text-opacity));
}
.text-gray-900 {
  --text-opacity: 1;
  color: #1a202c;
  color: rgba(26, 32, 44, var(--text-opacity));
}
.underline {
  text-decoration: underline;
}
.antialiased {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
.w-5 {
  width: 1.25rem;
}
.w-8 {
  width: 2rem;
}
.w-auto {
  width: auto;
}
.grid-cols-1 {
  grid-template-columns: repeat(1, minmax(0, 1fr));
}
@media (min-width: 640px) {
  .sm\:rounded-lg {
    border-radius: 0.5rem;
  }
  .sm\:block {
    display: block;
  }
  .sm\:items-center {
    align-items: center;
  }
  .sm\:justify-start {
    justify-content: flex-start;
  }
  .sm\:justify-between {
    justify-content: space-between;
  }
  .sm\:h-20 {
    height: 5rem;
  }
  .sm\:ml-0 {
    margin-left: 0;
  }
  .sm\:px-6 {
    padding-left: 1.5rem;
    padding-right: 1.5rem;
  }
  .sm\:pt-0 {
    padding-top: 0;
  }
  .sm\:text-left {
    text-align: left;
  }
  .sm\:text-right {
    text-align: right;
  }
}
@media (min-width: 768px) {
  .md\:border-t-0 {
    border-top-width: 0;
  }
  .md\:border-l {
    border-left-width: 1px;
  }
  .md\:grid-cols-2 {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}
@media (min-width: 1024px) {
  .lg\:px-8 {
    padding-left: 2rem;
    padding-right: 2rem;
  }
}
@media (prefers-color-scheme: dark) {
  .dark\:bg-gray-800 {
    --bg-opacity: 1;
    background-color: #2d3748;
    background-color: rgba(45, 55, 72, var(--bg-opacity));
  }
  .dark\:bg-gray-900 {
    --bg-opacity: 1;
    background-color: #1a202c;
    background-color: rgba(26, 32, 44, var(--bg-opacity));
  } 
  .dark\:border-gray-700 {
    --border-opacity: 1;
    border-color: #4a5568;
    border-color: rgba(74, 85, 104, var(--border-opacity));
  }
  .dark\:text-white {
    --text-opacity: 1;
    color: #fff;
    color: rgba(255, 255, 255, var(--text-opacity));
  }
  .dark\:text-gray-400 {
    --text-opacity: 1;
    color: #cbd5e0;
    color: rgba(203, 213, 224, var(--text-opacity));
  }
}

body {
  font-family: "Open Sans", sans-serif !important;
  color: #333;
  margin: 0;
}

*:focus {
  outline: none;
}
.navbar-center {
  position: absolute;
  left: 50%;
  font-size: 120%;
}
.colored-section {
  background-color: #f6f6f6;
}
/* Extra small devices (phones, 600px and down) */
@media only screen and (max-width: 600px) {
  .section-main-container {
    margin-top: 71px;
    padding-top: 40px;
    padding-bottom: 40px;
  }
}
/* Small devices (portrait tablets and large phones, 600px and up) */
@media only screen and (min-width: 600px) {
  .section-main-container {
    margin-top: 10px;
    padding-top: 40px;
    padding-bottom: 40px;
  }
}
/* Medium devices (landscape tablets, 768px and up) */
@media only screen and (min-width: 768px) {
  .section-main-container {
    margin-top: 10px;
    padding-top: 40px;
    padding-bottom: 40px;
  }
}
/* Large devices (laptops/desktops, 992px and up) */
@media only screen and (min-width: 992px) {
  .section-main-container {
    margin-top: 10px;
    padding-top: 40px;
    padding-bottom: 40px;
  }
}
/* Extra large devices (large laptops and desktops, 1200px and up) */
@media only screen and (min-width: 1200px) {
  .section-main-container {
    margin-top: 78px;
    padding-top: 40px;
    padding-bottom: 40px;
  }
}
.noselect {
  -webkit-touch-callout: none;
  /* iOS Safari */
  -webkit-user-select: none;
  /* Safari */
  -khtml-user-select: none;
  /* Konqueror HTML */
  -moz-user-select: none;
  /* Firefox */
  -ms-user-select: none;
  /* Internet Explorer/Edge */
  user-select: none;
  
}

.form-group {
  white-space: nowrap;
}
.btn {
  background-color: #0068ca;
  color: white;
  border-radius: 10px;
  border: 0px solid;
  box-shadow: 0 0 10px 4px #e6e6e6;
}
.text-input {
  border: 0px solid #d2e2e6;
  padding: 10px;
}
.mb3 {
  color: red;
}
#about {
  /* background-image: url(""); */
  background-size: cover;
  color: white;
}
.para .lead {
  margin-top: 8%;
}
/*Testimonial starts*/
.card {
  box-shadow: 0 0 8px 4px #e6e6e6;
  transition: 0.8s;
  box-sizing: border-box;
  border-radius: 7px !important;
}
.card-main {
  padding: 50px;
  border-radius: 10px;
  margin-top: 50px;
  margin-bottom: 50px;
  box-shadow: 0 0 10px 4px #e6e6e6;
}
.card-0 {
  color: #fff;
  background-color: #001767;
  position: relative;
  margin-left: 70px;
  border-radius: 10px;
  min-height: 312px;
}
.carousel-indicators li {
  cursor: pointer;
  border-radius: 50% !important;
  width: 10px;
  height: 10px;
}
.profile {
  color: #000;
  background-color: #fdc031;
  position: absolute;
  left: -70px;
  top: 17%;
  border-radius: 8px;
  border-top-left-radius: 0px;
  border-bottom-right-radius: 0px;
}
.profile-pic {
  width: 120px;
  height: 120px;
  border-bottom-left-radius: 10px;
  border-top-right-radius: 10px;
}
.open-quotes {
  margin-left: 130px;
  margin-top: 100px;
}
.content {
  margin-left: 150px;
  margin-right: 80px;
}
.close-quotes {
  margin-bottom: 100px;
  margin-right: 60px;
}
@media screen and (max-width: 365px) {
  .content {
    margin-left: 120%;
    margin-right: 50px;
    margin-top: -5%;
    font-size: 8px;
  }
  .open-quotes {
    margin-left: 100px;
    margin-top: 8%;
  }
  .card-0 {
    height: 90%;
    width: 85%;
  }
}
@media screen and (max-width: 600px) {
  .card-main {
    padding: 30px 5px;
  }
  .card-0 {
    height: 350px;
  }
  .profile {
    top: 24%;
  }
  .profile-pic {
    width: 80px;
    height: 80px;
  }
  .open-quotes {
    margin-left: 100px;
    margin-top: 5%;
  }
  .content {
    margin-left: 120px;
    margin-right: 50px;
  }
  .close-quotes {
    margin-right: 30px;
  }
}
/*testimonial ends*/
/*team starts*/
.team {
  border-radius: 10px;
  /* box-shadow: 0 0 8px 4px #e6e6e6; */
  transition: 0.8s;
  box-sizing: border-box;
  border-radius: 7px !important;
}
.p1 {
  font-weight: lighter !important;
  color: #333;
  font-size: 21px;
}
.p2 {
  font-weight: lighter !important;
  color: #333;
}
small {
  font-weight: bold;
  color: #333;
}
/*team ends*/
/* What we offer starts */
.services {
  width: 100%;
  text-align: center;
}
.services .title-section {
  word-wrap: break-word;
}
.services .title-section span {
  display: block;
  color: #333;
  font-weight: 700;
  font-size: 18px;
  text-transform: uppercase;
  line-height: 18px;
}
.services .title-section .main {
  color: #333;
  font-size: 56px;
  line-height: normal;
  font-weight: 900;
  text-align: center;
  text-transform: uppercase;
  margin: 0px;
  padding: 0px;
}
.services .feature {
  position: relative;
  margin: 45px 0px;
}
.services .feature .title {
  float: right;
  width: 80%;
  padding-left: 20px;
  padding-right: 70px;
}
.services .feature .title p {
  font-weight: 700;
  color: #333333;
  font-size: 20px;
  line-height: normal;
  text-transform: uppercase;
  margin-bottom: 10px;
}
/* Extra small devices (phones, 600px and down) */
@media only screen and (max-width: 600px) {
  .services .feature .description p {
    font-family: "Lato", sans-serif;
    color: #44495e;
    font-size: 14px;
    line-height: 18px;
    height: 80px;
    font-weight: 500;
    /*overflow: hidden;*/
    text-align: justify;
  }
}
/* Small devices (portrait tablets and large phones, 600px and up) */
@media only screen and (min-width: 600px) {
  .services .feature .description {
    float: right;
    width: 80%;
  }
  .services .feature .description p {
    font-family: "Lato", sans-serif;
    color: #44495e;
    font-size: 14px;
    line-height: 18px;
    height: 80px;
    font-weight: 500;
    /*overflow: hidden;*/
    text-align: justify;
  }
}
/* Medium devices (landscape tablets, 768px and up) */
@media only screen and (min-width: 768px) {
  .services .feature .description {
    float: right;
    width: 80%;
  }
  .services .feature .description p {
    font-family: "Lato", sans-serif;
    color: #44495e;
    font-size: 15px;
    line-height: 20px;
    height: 90px;
    font-weight: 500;
    /*overflow: hidden;*/
    text-align: justify;
  }
  .line-break {
    display: none;
  }
}
/* Large devices (laptops/desktops, 992px and up) */
@media only screen and (min-width: 992px) {
  .services .feature .description {
    float: right;
    width: 80%;
    padding-left: 20px;
    padding-right: 70px;
  }
  .services .feature .description p {
    /*font-family: 'Lato', sans-serif;*/
    color: #44495e;
    font-size: 15px;
    line-height: 20px;
    height: 90px;
    font-weight: 500;
    overflow: hidden;
    text-align: justify;
  }
  .line-break {
    display: none;
  }
}
/* Extra large devices (large laptops and desktops, 1200px and up) */
@media only screen and (min-width: 1200px) {
  .services .feature .description {
    float: right;
    width: 80%;
    padding-left: 20px;
    padding-right: 70px;
  }
  .services .feature .description p {
    font-family: "Lato", sans-serif;
    color: #44495e;
    font-size: 15px;
    line-height: 20px;
    height: 90px;
    font-weight: 500;
    overflow: hidden;
    text-align: justify;
  }
  .line-break {
    display: none;
  }
}
.services .feature .image {
  float: left;
  width: 20%;
}
.services .feature .image img {
  height: auto;
  max-width: 100%;
}
.services .feature .image-right {
  float: right;
  width: 20%;
}
.services .feature .image-right img {
  height: auto;
  max-width: 100%;
}
.title-section h2 {
  color: #333;
  font-weight: 700;
}
/*contact form starts*/
/* .contact-form {
  background: #fff;
  margin-top: 10%;
  margin-bottom: 5%;
  width: 100%;
}
.contact-form .form-control {
  border-radius: 1rem;
}
.contact-image {
  text-align: center;
}
.contact-image img {
  border-radius: 6rem;
  width: 11%;
  margin-top: -3%;
  margin-bottom: 8%;
  transform: rotate(29deg);
}
.contact-form form {
  padding: 7%;
}
.contact-form form .row {
  margin-bottom: -7%;
}
.contact-form h1 {
  margin-bottom: 8%;
  margin-top: -16%;
  text-align: center;
  color: #333;
}
.contact-form .btnContact {
  width: 50%;
  border: none;
  border-radius: 1rem;
  padding: 1.5%;
  background: #dc3545;
  font-weight: 600;
  color: #fff;
  cursor: pointer;
}
.btnContactSubmit {
  width: 50%;
  border-radius: 1rem;
  padding: 1.5%;
  color: #fff;
  background-color: #0062cc;
  border: none;
  cursor: pointer;
}
contact form ends */
/*Faq starts*/
#faq {
  margin-top: 7%;
  margin-bottom: 7%;
}
.card1 {
  /* box-shadow: 0 0 2px 2px #e6e6e6; */
  border: 1px solid #333;
  transition: 0.8s;
  box-sizing: border-box;
  border-radius: 7px !important;
}
.accordion-section .panel-default > .panel-heading {
  border: 0;
  background: #f4f4f4;
  padding: 0;
}
.accordion-section .panel-default .panel-title a {
  display: block;
  color: black;
  font-size: 1.2rem;
}
.panel-title a {
  text-decoration: none;
}
.accordion-section .panel-default .panel-title a:after {
  font-family: "FontAwesome";
  font-style: normal;
  font-size: 3rem;
  content: "";
  color: #333;
  float: right;
  margin-top: -12px;
}
.accordion-section .panel-default .panel-title a.collapsed:after {
  content: "";
}
.accordion-section .panel-default .panel-body {
  font-size: 1.2rem;
}
/*faq section ends*/

/*playstore app starts*/
.playstore {
  background-image: url("/imgs/bg4.jpg");
  color: white;
  background-repeat: no-repeat;
  background-size: cover;
}
/*playstore app ends*/
#client-testimonial-carousel {
  min-height: 200px;
}
/* Extra small devices (phones, 600px and down) */
@media only screen and (max-width: 600px) {
  #about h1 {
    font-size: 210%;
  }
  #about h4 {
    font-size: 150%;
  }
  .container-fluid p {
    font-size: 120%;
  }
  .container-fluid span {
    font-size: 120%;
  }
  .home-content-heading {
    font-size: 210%;
    z-index: 1;
  }
  .home-content-heading .lead {
    margin-top: 20%;
    font-size: 120%;
  }
  .title-section h2 {
    font-size: 210%;
  }
  
  #faq h1 {
    font-size: 210%;
  }
  .panel-title a {
    font-size: 150%;
  }
  .panel-body p {
    font-size: 90%;
  }
  .team-heading h1 {
    font-size: 210%;
  }
  .team-heading .p1 {
    font-size: 120%;
  }
  .contact-form h1 {
    font-size: 210%;
  }
  .playstore h1 {
    font-size: 210%;
  }
  .footer-text p {
    font-size: 120%;
  }
  .large-screeen {
    display: none;
  }
}
/* Small devices (portrait tablets and large phones, 600px and up) */
@media only screen and (min-width: 600px) {
  .home-content-heading {
    z-index: 1;
  }
  .playstore h1 {
    font-size: 210%;
  }
  .small-screeen {
    display: none;
  }
}
/* Medium devices (landscape tablets, 768px and up) */
@media only screen and (min-width: 768px) {
  .home-content-heading {
    z-index: 1;
  }
  .small-screeen {
    display: none;
  }
  .home-banner-image1 {
  }
}
/* Large devices (laptops/desktops, 992px and up) */
@media only screen and (min-width: 992px) {
  .home-content-heading {
    z-index: 1;
  }
  /* .home-banner-image1{
                margin-top: 20%;
                margin-left: 10%;
            }  */
  .home-banner-image {
    margin-left: 30px;
  }
}
/* Extra large devices (large laptops and desktops, 1200px and up) */
@media only screen and (min-width: 1200px) {
  .home-content-heading {
    z-index: 1;
    font-size: 40px;
  }
  .home-banner-image {
    padding: 10%;
    margin-right: 30px;
  }
}
.playstore h1 {
  margin-top: 4%;
}
/* .home-banner-image1{
            margin-top: 8%;
            margin-left: 10%;
        }  */

/*nav*/

.searchbox-wrap {
  border: 1px solid #f3f6f9;
  background-color: #f3f6f9;
  padding: 10px;
}
.search-input {
  width: 100%;
  border: 0px;
  background-color: #f3f6f9;
}

/* get trial animated button - START  */
.get-trial-button {
  border-radius: 4px;
  background-color: #fdc031;
  border: none;
  color: #333;
  text-align: center;
  font-size: 20px;
  padding: 10px;
  width: 240px;
  transition: all 0.5s;
  cursor: pointer;
}
.get-trial-button span {
  cursor: pointer;
  display: inline-block;
  position: relative;
  transition: 0.5s;
}
.get-trial-button span:after {
  content: "\00bb";
  position: absolute;
  opacity: 0;
  top: 0;
  right: -20px;
  transition: 0.5s;
}
.get-trial-button:hover span {
  padding-right: 25px;
}
.get-trial-button:hover span:after {
  opacity: 1;
  right: 0;
}

/*nav end*/


/* removing blue outline from buttons */
button:focus,
button:active {
  outline: none;
}
.offer-link {
  background-color: #001969;
  color: white;
  height: 100px;
  display: grid;
  place-items: center;
  place-content: center;
  font-weight: 500;
  cursor: pointer;
}
.active{
  background-color: #DBEAFE;
  /* border:none !important */
  /* color: #fff; */
}
.what-does-offer-prod-icon {
  font-size: 26px;
  padding: 10px;
}
.learn-more-link {
  text-decoration: none;
  color: #001969;
  font-size: 14px;
}
.learn-more-link:hover {
  text-decoration: none;
}
.product-name {
  font-weight: 700;
}
.product-description {
  font-weight: 600;
  font-size: 14px;
  line-height: 0 !important;
}
.get-this-prod-button {
  border-radius: 4px;
  background-color: #fdc031;
  border: none;
  color: #333;
  text-align: center;
  font-size: 14px;
  padding: 5px;
  width: 200px;
  transition: all 0.5s;
  cursor: pointer;
}
.get-this-prod-button span {
  cursor: pointer;
  display: inline-block;
  position: relative;
  transition: 0.5s;
}
.get-this-prod-button span:after {
  content: "\00bb";
  position: absolute;
  opacity: 0;
  top: 0;
  right: -20px;
  transition: 0.5s;
}
.get-this-prod-button:hover span {
  padding-right: 25px;
}
.get-this-prod-button:hover span:after {
  /* opacity: 1; */
  right: 0;
}
.first_saas:hover{
  background-color:#eef4ff;
}
.product-icon {
  /* width: 76px;
  height: 56px; */
}
.product-item-card {
  box-shadow: 0 0 0 0;
}
/* Extra small devices (phones, 600px and down) */
@media only screen and (max-width: 600px) {
  .product-item {
    border: 1px solid rgb(219, 219, 219);
    border-radius: 10px;
    margin-left: 8px;
    padding: 6px 6px 6px 6px !important;
    transition: 0.2s;
    /* background-color: #ffffff; */
  }
}
/* Small devices (portrait tablets and large phones, 600px and up) */
@media only screen and (min-width: 600px) {
  .product-item {
    border: 1px solid rgb(219, 219, 219);
    border-radius: 10px;
    margin-left: 6px;
    margin-right: 6px;
    padding: 6px 6px 6px 6px !important;
    transition: 0.2s;
    /* background-color: #ffffff; */
  }
}
/* Medium devices (landscape tablets, 768px and up) */
@media only screen and (min-width: 768px) {
  .product-item {
    border: 1px solid rgb(219, 219, 219);
    border-radius: 10px;
    margin-left: 12px;
    padding: 6px 6px 6px 6px !important;
    transition: 0.2s;
  }
}
/* Large devices (laptops/desktops, 992px and up) */
@media only screen and (min-width: 992px) {
  .product-item {
    border: 1px solid rgb(219, 219, 219);
    border-radius: 10px;
    margin-left: 12px;
    padding: 6px 6px 6px 6px !important;
    transition: 0.2s;
  }
}
/* Extra large devices (large laptops and desktops, 1200px and up) */
@media only screen and (min-width: 1200px) {
  .product-item {
    border: 1px solid rgb(219, 219, 219);
    border-radius: 10px;
    margin-left: 12px;
    padding: 6px 6px 6px 6px !important;
    transition: 0.2s;
    /* background-color: #ffffff; */
  }
}
.product-item:hover {
  box-shadow: 0 0 4px 1px rgb(219, 219, 219);
}
.col-carousel {
  margin: 0px 0px !important;
}

/*colred section*/

/* Extra small devices (phones, 600px and down) */
@media only screen and (max-width: 600px) {
  .icon_style {
    text-align: left;
    padding-right: 10px;
  }
}
/* Small devices (portrait tablets and large phones, 600px and up) */
@media only screen and (min-width: 600px) {
  .icon_style {
    text-align: left;
    padding-right: 10px;
  }
}
/* Medium devices (landscape tablets, 768px and up) */
@media only screen and (min-width: 768px) {
}
/* Large devices (laptops/desktops, 992px and up) */
@media only screen and (min-width: 992px) {
}
/* Extra large devices (large laptops and desktops, 1200px and up) */
@media only screen and (min-width: 1200px) {
}
.unique-style {
  font-weight: 600;
}
.icon_style {
  text-align: center;
  padding: 0px;
}
.lorem-style {
  margin-top: -4px;
  color: #3c3c3c;
  font-size: 14px;
}

/*section main container*/

.wiifm-container {
  box-shadow: 0 0 1px 1px rgb(219, 219, 219);
  padding: 6px;
  background-color: #ffffff;
  transition: 0.2s;
  margin: 14px;
   height: 240px;
}
.wiifm-container:hover {
  box-shadow: 0 0 6px 1px rgb(219, 219, 219);
}
.wiifm-img {
  width: 50%;
}

/*colored section*/

/*whats in it for me*/

.team-container {
  border: 1px solid rgb(219, 219, 219);
  border-radius: 10px;
  padding: 6px;
  transition: 0.2s;
}
.team-container:hover {
  box-shadow: 0 0 4px 1px rgb(219, 219, 219);
}
.p-adv {
  font-size: 12px;
}
p{
  margin-bottom: 0px;
}
.active {
  cursor: pointer;
}
.active:hover {
  background-color: #DBEAFE;
  
}
h6{
  margin-bottom:0.1rem;
}
h4{
  margin-bottom:0.1rem;
}
.text-lg {
  font-size: 1rem;
}
</style>
   


           